namespace Matrix.Data {
    export class AccountTypeColumns {
        static columnsKey = 'Data.AccountType';
    }
}
